module.exports = __webpack_public_path__ + "static/media/Results-2.5d285181.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/testimonials/social/Results-2.jpg
// module id = 384
// module chunks = 0